// extracted by mini-css-extract-plugin
export default {"main":"WidgetSection_main__77SR-","widget_wrap":"WidgetSection_widget_wrap__kQJjJ","widget":"WidgetSection_widget__F0soa"};